import { useMutation } from '@tanstack/react-query';
import {
  CreateOrderAdjustmentResponse,
  createOrderAdjustments,
} from 'config/requests/orderAdjustments';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useNotify } from 'react-admin';
import { ErrorData } from 'types/embedded/error';

import { OrderAdjustmentsFormValues } from './useOrderAdjustmentsForm';

export function useCreateOrderAdjustments(
  onSuccess: (result: CreateOrderAdjustmentResponse) => void,
) {
  const translate = useTypedTranslate();
  const notify = useNotify();

  const mutation = useMutation({
    mutationFn: (data: OrderAdjustmentsFormValues) => createOrderAdjustments(data),
    onSuccess: async (result) => {
      onSuccess(result);
      notify(translate('app.orderAdjustmentsReport.adjustmentRequestCreatedSuccessfully'), {
        type: 'success',
      });
    },
    onError: (e: ErrorData) => {
      const messages = [
        ...(e?.errors?.map((err) => err?.title) ?? []),
        ...(e?.violations?.map((v) => v?.title ?? v?.message) ?? []),
      ].filter(Boolean);

      notify(`${translate('app.common.error')}: ${messages.join('\n')}`, {
        type: 'error',
        multiLine: true,
      });
    },
  });

  return { createOrderAdjustments: mutation };
}
